const types = {
  BUYING: 'buying',
  SELLING: 'selling',
};

const statuses = {
  CURRENT: 'current',
  PENDING: 'pending',
  HISTORY: 'history',
};

const buyingColumns = {
  history: [
    {
      key: 'title',
      sort: 'name',
      name: 'Item',
      accessor: 'product.shoe',
    },
    {
      key: 'orderNumber',
      name: 'Order Number',
      accessor: 'orderNumber',
    },
    {
      key: 'matchedWithDate',
      sort: 'matched_with_date',
      name: 'Purchase Date',
      accessor: 'matchedWithDate',
    },
    {
      key: 'amount',
      sort: 'amount',
      name: 'Price',
      accessor: 'localAmount',
    },
    {
      key: 'state',
      sort: 'state',
      name: 'Status',
      accessor: 'shipByDate',
    },
  ],
  pending: [
    {
      key: 'title',
      sort: 'name',
      name: 'Item',
      accessor: 'product.shoe',
    },
    {
      key: 'orderNumber',
      name: 'Order Number',
      accessor: 'orderNumber',
    },
    {
      key: 'matchedWithDate',
      sort: 'matched_with_date',
      name: 'Purchase Date',
      accessor: 'matchedWithDate',
    },
    {
      key: 'amount',
      sort: 'amount',
      name: 'Price',
      accessor: 'localAmount',
    },
    {
      key: 'state',
      sort: 'state',
      name: 'Status',
      accessor: 'shipByDate',
    },
    {
      key: 'payFail',
      name: '',
      accessor: 'payFail',
    },
  ],
  current: [
    {
      key: 'title',
      sort: 'name',
      name: 'Item',
      accessor: 'product.shoe',
    },
    {
      key: 'coloredBid',
      sort: 'amount',
      name: 'Your Bid Price',
      accessor: 'localAmount',
    },
    {
      key: 'highestBid',
      sort: 'highest_bid',
      name: 'Highest Bid',
      accessor: 'product.market.highestBid',
    },
    {
      key: 'lowestAsk',
      sort: 'lowest_ask',
      name: 'Lowest Ask',
      accessor: 'product.market.lowestAsk',
    },
    {
      key: 'expiresAt',
      sort: 'expires_at',
      name: 'Expires',
      accessor: 'expiresAt',
    },
    {
      key: 'bidEditDelete',
      name: '',
      accessor: 'bidEditDelete',
    },
  ],
};

const Profile = {
  types,
  statuses,
  buyingColumns,
};

export default Profile;
